import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { PaymentAcquirerSearch } from "src/app/core/models/payment-acquirer-model";
import { PaymentAcquirerReferenceService } from "src/app/core/services/system-services/payment-acquirer-reference.service";
import { PaymentAcquirerSearchCriteria, PaymentAcquirerUpdateStatusCode } from "./payment-acquirer-search.model";
import { tap } from "rxjs/operators";
import { StatusReferenceModel } from "src/app/core/models/reference-model/reference-general-model";
import { StatusReferenceService } from "src/app/core/services/system-services";

@Injectable({
    providedIn: 'root'
})
export class PaymentAcquirerSearchService {

    private _criteria$ = new BehaviorSubject<Map<string, PaymentAcquirerSearchCriteria>>(new Map())
    private _paymentAcquirers$ = new BehaviorSubject<PaymentAcquirerSearch[]>([])
    private _statusReferenceModels$ = new BehaviorSubject<StatusReferenceModel[]>([])
    private _callSearch$ = new BehaviorSubject<boolean>(false)
    private _refresh$ = new Subject()

    get criteria$() {
        return this._criteria$.asObservable()
    }
    get paymentAcquirers$() {
        return this._paymentAcquirers$.asObservable()
    }
    get statusReferenceModels$() {
        return this._statusReferenceModels$.asObservable()
    }
    get callSearch$() {
        return this._callSearch$.asObservable()
    }
    get refresh$() {
        return this._refresh$.asObservable()
    }

    constructor(private paymentAcquirerReferenceService: PaymentAcquirerReferenceService,
        private statusReferenceService: StatusReferenceService) {
    }

    getPaymentAcquirersSearch(criteria: PaymentAcquirerSearchCriteria): Observable<PaymentAcquirerSearch[]> {
        return this.paymentAcquirerReferenceService.search(criteria.statusCode ?? '', criteria.paymentAcquirerName ?? '', criteria.paymentAcquirerCode ?? '')
            .pipe(
                tap(response => this._paymentAcquirers$.next(response))
            )
    }

    updateStatusCode(obj: PaymentAcquirerUpdateStatusCode): Observable<never> {
        return this.paymentAcquirerReferenceService.updateStatusCode(obj)
    }

    loadStatusReference(): Observable<StatusReferenceModel[]> {
        return this.statusReferenceService.getAll().pipe(
            tap(response => this._statusReferenceModels$.next(response))
        )
    }

    clearSearch() {
        this._paymentAcquirers$.next([])
    }
    callSearch() {
        this._callSearch$.next(true)
    }

    refresh() {
        this._refresh$.next()
    }

    saveCriteria(tabId: string, criteria: PaymentAcquirerSearchCriteria) {
        const dataMap = this._criteria$.getValue()
        dataMap.set(tabId, { ...criteria })
        this._criteria$.next(dataMap)
    }

}